import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { computed } from 'vue';
import { factor } from '@/composable/lib.ts';

interface Props {
  n?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FactorStr',
  props: {
    n: { default: 1 }
  },
  setup(__props: any) {

const props = __props as { n: number };



const ar = computed( () => factor(props.n) );
const isPrime = computed( () => ar.value.length == 1 && ar.value[0].e == 1 );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    (_unref(isPrime))
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(素数)"))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ar), (obj, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: obj.p
            }, [
              (i != 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "×"))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(obj.p), 1),
              (obj.e > 1)
                ? (_openBlock(), _createElementBlock("sup", _hoisted_4, _toDisplayString(obj.e), 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
  ]))
}
}

})